import script from "./ProfileTax.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileTax.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import SelectInput from "@/components/neue/SelectInput.vue";
script.components = Object.assign({}, { SelectInput }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { SelectInput }, script.__o.components);}